import React, { Component } from "react";
import { connect } from "react-redux";

import { createProductStatus } from "actions/productStatus";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/ProductStatus/Form";

class ProductStatusCreate extends Component {
  handleFormSubmit = data => {
    this.createProductStatus(data);
  };

  createProductStatus(data) {
    const { toggleNotification, toggleFullPageSpinner, createProductStatus, history } = this.props;
    toggleFullPageSpinner(true);
    createProductStatus(data)
      .then(() => {
        toggleNotification(true, { message: "Created ProductStatus Success", infoClassName: "is-success" });
        history.push(`/product-status`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  render() {
    return <Form handleFormSubmit={this.handleFormSubmit} />;
  }
}

export default connect(
  null,
  {
    createProductStatus,
    toggleFullPageSpinner,
    toggleNotification
  }
)(ProductStatusCreate);



// WEBPACK FOOTER //
// ./src/pages/ProductStatus/Create/index.js